import { BUSINESS_OFFERS, INSURANCE_OFFERS, ACTIONS, COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';

const SPECIAL_OFFERS_LABELS = {
    [COMMON_OFFERS.savings]: 'Вклады',
    [COMMON_OFFERS.accumulative]: 'Накопительные счета',
    [COMMON_OFFERS.credits]: 'Кредиты',
    [COMMON_OFFERS.mortgage]: 'Ипотека',
    [COMMON_OFFERS.creditCards]: 'Кредитные карты',
    [COMMON_OFFERS.debitCards]: 'Дебетовые карты',
    [COMMON_OFFERS.loan]: 'Займы',
    [COMMON_OFFERS.brokerskoeObsluzhivanie]: 'Брокерское обслуживание',
    [COMMON_OFFERS.bankrotstvo]: 'Банкротство физических лиц',
    [ACTIONS.osago]: 'Осаго',
    [INSURANCE_OFFERS.insuranceOsago]: 'Страхование ОСАГО',
    [INSURANCE_OFFERS.dms]: 'ДМС',
    [INSURANCE_OFFERS['strahovanie-domov']]: 'Страхование домов',
    [INSURANCE_OFFERS['strahovka-kriticheskie-bolezni']]: 'Страхование от критических заболеваний',
    [INSURANCE_OFFERS['strahovka-ot-klescha']]: 'Страховка от укуса клеща',
    [BUSINESS_OFFERS.biznesRegistration]: 'Регистрация бизнеса',
    [BUSINESS_OFFERS.biznesRko]: 'РКО',
    [BUSINESS_OFFERS.biznesKredity]: 'Бизнес-кредиты',
    [BUSINESS_OFFERS.biznesEkvajring]: 'Эквайринг',
    [BUSINESS_OFFERS.biznesAccounting]: 'Бухгалтерия для бизнеса',
    [BUSINESS_OFFERS.bankovskieGarantii]: 'Банковские гарантии',
    // [BUSINESS_OFFERS.biznesDepozit]: 'Вклады для бизнеса',
    [BUSINESS_OFFERS.biznesMarketplace]: 'Бизнес на маркетплейсах',
    [BUSINESS_OFFERS.biznesLeasing]: 'Лизинг',
    [BUSINESS_OFFERS.zarplatnyjProekt]: 'Зарплатные проекты',
    [BUSINESS_OFFERS.biznesVed]: 'ВЭД',
};
const LEARNING_TYPE_LABELS = {
    typeProgramming: 'Программирование',
    typeAnalytics: 'Аналитика',
    typeMarketing: 'Маркетинг',
    typeDesign: 'Дизайн',
    typeManagement: 'Бизнес и управление',
    typeAdmin: 'Администрирование',
    typeFinance: 'Финансы',
    typeLanguage: 'Иностранные языки',
    typeCreativity: 'Творчество и создание контента',
    typeSoftSkills: 'Саморазвитие и soft skills',
    typeApplication: 'Рукоделие',
    typeBeauty: 'Красота и здоровье',
    typePO: 'Прикладные программы',
    typeSport: 'Спорт',
    typeDPO: 'ДПО',
};

export { LEARNING_TYPE_LABELS, SPECIAL_OFFERS_LABELS };
//# sourceMappingURL=labels.js.map
